export default __webpack_public_path__ + "static/leaf-pattern-canary-ba3a560d94d437f7f9d41890c6880c42.png";